import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';

interface InputRangeProps {
  ClassName?: string;
  HandleChange: (event: number) => void;
  Id: string;
  IsDisabled?: boolean;
  Label?: string;
  Max: number;
  Min?: number;
  Name?: string;
  Step?: number;
  Unit: string;
  Value: number;
}

const InputRange = ({
  ClassName = 'mb-24',
  HandleChange,
  Id,
  IsDisabled = false,
  Label = null,
  Max,
  Min = 0,
  Name = null,
  Step = 10,
  Unit,
  Value,
}: InputRangeProps) => {
  const HandleRangeChange = (Event: React.ChangeEvent<HTMLInputElement>) => {
    HandleChange(Number(Event.target.value));
  };

  return (
    <Form.Group className={ClassName} id={Id}>
      {Label && <Form.Label>{Label}</Form.Label>}
      <Form.Range
        disabled={IsDisabled}
        min={Min}
        max={Max}
        name={Name}
        onChange={e => HandleRangeChange(e)}
        step={Step}
        value={Value}
      />
      <p className="mb-0 text-center">
        <small>
          <span>{Value.toString()}</span>
          <span> {Unit}</span>
        </small>
      </p>
    </Form.Group>
  );
};

// InputRange.defaultProps = {
//   ClassName: 'mb-24',
//   IsDisabled: false,
//   Label: null,
//   Min: 0,
//   Name: null,
//   Step: 10,
// };

export default InputRange;
export { InputRange };
export type { InputRangeProps };
